import model from "@/mixins/model";

export default {
    mixins: [model],
    model() {
        return {
            lead: []
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {

            return this.dispatch((resolve, reject) => {

                this.$http.request({ url: 'leads/:lead/client_data' })
                    .then((response) => {

                        this.model.lead = response.data.lead;
                    })
                    .then(resolve)
                    .catch(reject);

            });


        },
    }
}